import * as Yup from 'yup';

const ValidatorExtraFields = Yup.array().of(
  Yup.object().shape({
    label: Yup.string()
      .min(3, 'Mínimo 3 caracteres')
      .required('Campo obrigatório')
      .typeError('Campo inválido'),
    value: Yup.number()
      .moreThan(0, 'O número deve ser maior que zero')
      .required('Este campo é obrigatório'),
  }),
);

export default ValidatorExtraFields;
